String.prototype.format = function (args) {
    var result = this;
    if (arguments.length > 0) {
        if (arguments.length == 1 && typeof (args) == "object") {
            for (var key in args) {
                if (args[key] != undefined) {
                    var reg = new RegExp("({" + key + "})", "g");
                    result = result.replace(reg, args[key]);
                }
            }
        } else {
            for (var i = 0; i < arguments.length; i++) {
                if (arguments[i] != undefined) {
                    //var reg = new RegExp("({[" + i + "]})", "g");//这个在索引大于9时会有问题，谢谢何以笙箫的指出
                    var reg = new RegExp("({)" + i + "(})", "g");
                    result = result.replace(reg, arguments[i]);
                }
            }
        }
    }
    return result;
};

if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

/**
 * 截取长度，显示省略号
 * @param lens
 * @returns {string}
 */
String.prototype.sliceLength = function (lens) {
    var msg = this.slice(0, this.length);
    var len = 0;
    for (var i = 0; i < msg.length; i++) {
        if (msg.charCodeAt(i) > 127 || msg.charCodeAt(i) === 94) {
            len += 2;
            if (len - 1 >= lens) {
                return msg.slice(0, i) + '…';
            }
        } else {
            len++;
            if (len - 1 >= lens) {
                return msg.slice(0, i) + '…';
            }
        }
    }
    return msg;
};

/////////////////////////时间日期////////////////////////////////
Date.prototype.format = function (format) {
    var time = this;
    var date = {
        "M+": time.getMonth() + 1,
        "d+": time.getDate(),
        "h+": time.getHours(),
        "m+": time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes(),
        "s+": time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds(),
        "S+": time.getMilliseconds() //毫秒数
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1
                ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
};

Array.prototype.insert = function (position, element) {
    this.splice(position, 0, element);
};